import {getThisMonth} from "../../../common/DateUtils";
import {hostList} from "../../signup/entity/Common";
import {Link} from "react-router-dom";
import SelectBoxActive from "../../../components/common/SelectBoxActive";
import SelectAdminModal from "../../../components/common/SelectAdminModal";
import {atom} from "jotai/index";
import moment from "moment";
import {phoneNumFormat} from "../../../common/StringUtils";
import {updateAdmin} from "../../../services/Platform/ManageAdminAxios";

export const adminInfoAtom = atom({})
/**
 * 상품 수집 기간 검색 아톰
 * @type {PrimitiveAtom<{endDate: string, stateDate: string}> & WithInitialValue<{endDate: string, stateDate: string}>}
 */
export const searchConditionAtom = {
  searchStartDate: getThisMonth().startDay,
  searchEndDate: getThisMonth().endDay,
  searchType: 'DEFAULT',
  keyword: '',
  pageSize: 1000,
  currentPage:1,
  username:''
}

export const selectAccountUseInfo = [
  {id: "1", value: "ALL", label: "전체"},
  {id: "2", value: "Y", label: "활성화"},
  {id: "3", value: "N", label: "비활성화"},
]
export const AdminActiveList = [
  {id: "0", value: "NORMAL", label: "활성화"},
  {id: "1", value: "SUSPEND", label: "비활성화"},
]
export const searchAccountInfo = {
  mediaType: 'ALL',
  selectAdminType: '',
  mediaSearchType: null,
  username: '',
  siteName: '',
  phoneNumber: '',
  activeYn: 'ALL',
  pageSize: 1000,
  currentPage: 1,
  searchText: ''
}
export const columnAdminData = [
  {
    name: 'email',
    header: '아이디',
    defaultWidth: 220, //가변 사이즈
    textEllipsis: false, // ... 표시
    cellProps: {
      style: {
        textDecoration: 'underline'
      }
    },
    render: ({value, data}) => {
      return (
          <SelectAdminModal formType={'admin'} title={'관리자 정보'} buttonText={value} data={data}/>
      )
    }
  },
  {
    name: 'name',
    header: '담당자명'
  },
  {
    name: 'phoneNumber',
    header: '연락처',
    render: ({value}) => <span>{phoneNumFormat(value)}</span>
  },
  {
    name: 'createdAt',
    header: '생성 일시',
    render: ({value}) => {
      return (
          <span>{moment(value).format('YYYY년 MM월 DD일')}</span>
      )
    }
  },
  {
    name: 'status',
    header: '사용 여부',
    render: ({ value, cellProps }) => {
      return <SelectBoxActive
          options={AdminActiveList}
          value={value}
          onSelect={async (item)=>{ await updateAdmin({...cellProps.data, activeYn: item === 'NORMAL' ? 'Y' : 'N'});}} />
    }
  },
]
export const columnTermData = [
  {
    name: 'title',
    header: '약관 명',
    render: (props) => {
      return (
          <Link to={'/board/platformTermDetail'} state={{id: props.data.id}}
                style={{display: 'inline-block', width: '100%', textAlign: "center"}}>{props.value}</Link>
      )
    },
    flex:4
  },
  {
    name: 'requiredAgreeYn',
    header: '필수 여부',
    textAlign: 'center',
    render: (props) => {
      return (
          <p>{props.value}</p>
      )
    },
    flex:1
  },
  // {
  //   name: 'patchVersion',
  //   header: '버전',
  // },
]

/**
 * 호스트 타입
 * @type
 */
export const hostType = [
  {key: 100, value: "ALL", label: "전체"},
  ...hostList
]
